<template>
  <v-navigation-drawer
    id="filtering"
    v-if="filterDrawer"
    v-model="filterDrawer"
    fixed
    temporary
    right
    height="auto"
    :width="571"
    class="mt-xs-0 mt-sm-0 mt-md-12 mt-lg-12 mt-xl-12"
    :style="$vuetify.breakpoint.mobile ? { 'max-height': '500px' } : { 'max-height': '700px' }"
    style="border-radius: 12px;"
  >
    <v-card elevation="0" class="fill-height">
      <v-card-title style="border-bottom: 1px solid #C3C2C7;">
        <v-row class="mx-0 px-2" align="center">
          <v-col cols="11" class="text-center d-flex justify-center align-center text-bold">
            Filters
          </v-col>
          <v-col cols="1">
            <v-btn fab small text @click="filterDrawer = false">
              <v-icon color="neutral500">
                mdi-close
              </v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text :v-if="loadingFilterComponents == 0">
        <v-row class="mt-0">
          <v-col cols="12" class="d-flex justify-center" id="filtering-toggle">
            <v-row no-gutters class="overflow-x-auto">
              <v-btn-toggle v-model="toggle_search" rounded mandatory class="d-flex">
                <v-btn value="resources">
                  Services
                </v-btn>
                <v-btn value="providers">
                  Providers
                </v-btn>
                <v-btn value="equipment">
                  Equipment
                </v-btn>
                <v-btn value="patents">
                  Patents
                </v-btn>
                <v-btn value="hostingInstitutions">
                  Hosting Institutions
                </v-btn>
              </v-btn-toggle>
            </v-row>
          </v-col>
        </v-row>

        <!-- Hosting Institutions -->
        <v-row class="mx-0 px-2 mb-auto" v-show="toggle_search == 'hostingInstitutions'">
          <v-col cols="12">
            <v-text-field
              rounded
              v-model.trim="hosting.text"
              placeholder="Search"
              outlined
              dense
              prepend-inner-icon="mdi-magnify"
              hide-details
              clearable
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <label>Ecosystem Stakeholder Profile:</label>
            <v-autocomplete
              v-model="hosting.ecosystemStakeholders"
              class="mt-2"
              :items="ecosystemStakeholders"
              :item-value="'id'"
              :item-text="'name'"
              outlined
              multiple
              clearable
              :placeholder="'Ecosystem Stakeholder Profile'"
              hide-details
              dense
            >
            </v-autocomplete>
          </v-col>
          <v-col cols="12">
            <label>Areas of Activities:</label>
            <v-autocomplete
              v-model="hosting.areasOfActivity"
              class="mt-2"
              :items="areasOfActivity"
              :item-value="'id'"
              :item-text="'name'"
              outlined
              multiple
              clearable
              :placeholder="'Areas of Activities'"
              hide-details
              dense
            >
            </v-autocomplete>
          </v-col>
        </v-row>

        <!-- Patents -->
        <v-row class="mx-0 px-2 mb-auto" v-show="toggle_search == 'patents'">
          <v-col cols="12">
            <v-text-field
              rounded
              v-model.trim="patent.text"
              placeholder="Search"
              outlined
              dense
              prepend-inner-icon="mdi-magnify"
              hide-details
              clearable
            ></v-text-field>
          </v-col>
          <v-col cols="12" class="my-0 py-0">
            <label>Filling Date:</label>
            <v-menu
              v-model="fillingDateMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  outlined
                  v-model="fillingDateRangeText"
                  append-icon="mdi-calendar"
                  placeholder="Any Filling Date"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  dense
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="patent.fillingDate"
                range
                @change="fillingDateMenu = false"
                color="rgba(157, 87, 244, 1)"
                :first-day-of-week="1"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" class="my-0 py-0">
            <label>Issue Date:</label>
            <v-menu
              v-model="issueDateMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  outlined
                  v-model="issueDateRangeText"
                  append-icon="mdi-calendar"
                  placeholder="Any Issue Date"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  dense
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="patent.issueDate"
                range
                @change="issueDateMenu = false"
                color="rgba(157, 87, 244, 1)"
                :first-day-of-week="1"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" class="my-0 py-0">
            <label>Expiration Date:</label>
            <v-menu
              v-model="expirationDateMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  outlined
                  v-model="expirationDateRangeText"
                  append-icon="mdi-calendar"
                  placeholder="Any Expiration Date"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  dense
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="patent.expirationDate"
                range
                @change="expirationDateMenu = false"
                color="rgba(157, 87, 244, 1)"
                :first-day-of-week="1"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" class="my-0 py-0">
            <label>{{ 'Patent Status:' }}</label>
            <v-autocomplete
              class="mt-2"
              v-model="patent.patentStatuses"
              :items="patentStatuses"
              :item-value="'id'"
              :item-text="'name'"
              outlined
              multiple
              clearable
              :placeholder="'Patent Status'"
              hide-details
              dense
            ></v-autocomplete>
          </v-col>
          <v-col cols="12">
            <label>Technology:</label>
            <v-autocomplete
              v-model="patent.technologies"
              class="mt-2"
              :items="technologies"
              :item-value="'id'"
              :item-text="'name'"
              outlined
              multiple
              clearable
              :placeholder="'Technologoy'"
              hide-details
              dense
            >
            </v-autocomplete>
          </v-col>
          <v-col cols="12">
            <label>{{ 'Provider' }}</label>
            <v-autocomplete
              class="mt-2"
              v-model="patent.providers"
              :items="providers"
              :item-value="'id'"
              :item-text="'name'"
              outlined
              multiple
              clearable
              :placeholder="'Provider'"
              hide-details
              dense
            ></v-autocomplete>
          </v-col>
        </v-row>

        <!-- Equipment -->
        <v-row class="mx-0 px-2 mb-auto" v-show="toggle_search == 'equipment'">
          <v-col cols="12">
            <v-text-field
              rounded
              v-model.trim="equipment.text"
              placeholder="Search"
              outlined
              dense
              prepend-inner-icon="mdi-magnify"
              hide-details
              clearable
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <label>{{ 'Hosting Institution:' }}</label>
            <v-autocomplete
              class="mt-2"
              v-model="equipment.institutions"
              :items="institutions"
              :item-value="'id'"
              :item-text="'name'"
              outlined
              multiple
              clearable
              :placeholder="'Hosting Institution'"
              hide-details
              dense
            ></v-autocomplete>
          </v-col>
          <v-col cols="12">
            <label>{{ 'Provider' }}</label>
            <v-autocomplete
              class="mt-2"
              v-model="equipment.providers"
              :items="providers"
              :item-value="'id'"
              :item-text="'name'"
              outlined
              multiple
              clearable
              :placeholder="'Provider'"
              hide-details
              dense
            ></v-autocomplete>
          </v-col>
          <v-col cols="12">
            <label>{{ 'Scientific Domain:' }}</label>
            <v-autocomplete
              class="mt-2"
              v-model="equipment.domains"
              :items="domains"
              @change="updateSubDomains(equipment.domains)"
              outlined
              multiple
              clearable
              :placeholder="'Scientific Domain'"
              hide-details
              dense
            ></v-autocomplete>
          </v-col>
          <v-col cols="12">
            <label>{{ 'Scientific Subdomain:' }}</label>
            <v-autocomplete
              class="mt-2"
              v-model="equipment.subDomains"
              :items="subDomains"
              :item-value="'id'"
              :item-text="'subDomain'"
              outlined
              multiple
              clearable
              :placeholder="'Scientific Subdomain'"
              hide-details
              dense
            ></v-autocomplete>
          </v-col>
          <v-col cols="12">
            <label>{{ 'Subcategory:' }}</label>
            <v-autocomplete
              class="mt-2"
              v-model="resource.equipmentSubCategories"
              :items="equipmentSubCategories"
              :item-value="'id'"
              :item-text="'subCategory'"
              outlined
              multiple
              clearable
              :placeholder="'Subcategory'"
              hide-details
              dense
            ></v-autocomplete>
          </v-col>
          <v-col cols="12">
            <label>{{ 'Access Mode:' }}</label>
            <v-autocomplete
              class="mt-2"
              v-model="equipment.accessModes"
              :items="accessModes"
              :item-value="'id'"
              :item-text="'name'"
              outlined
              multiple
              clearable
              :placeholder="'Access Mode'"
              hide-details
              dense
            ></v-autocomplete>
          </v-col>
          <v-col cols="12">
            <label>{{ 'Access Type:' }}</label>
            <v-autocomplete
              class="mt-2"
              v-model="equipment.accessTypes"
              :items="accessTypes"
              :item-value="'id'"
              :item-text="'name'"
              outlined
              multiple
              clearable
              :placeholder="'Access Type'"
              hide-details
              dense
            ></v-autocomplete>
          </v-col>
          <v-col cols="12">
            <label>{{ 'Target Users:' }}</label>
            <v-autocomplete
              class="mt-2"
              v-model="equipment.targets"
              :items="targets"
              :item-value="'id'"
              :item-text="'name'"
              outlined
              multiple
              clearable
              :placeholder="'Target Users'"
              hide-details
              dense
            ></v-autocomplete>
          </v-col>
          <!-- <v-col cols="6">
            <v-checkbox
              class="mt-0"
              v-model="equipment.noCost"
              :label="'No Cost'"
              hide-details
              dense
            ></v-checkbox>
          </v-col> -->
        </v-row>

        <!-- Services -->
        <v-row class="mx-0 px-2 mb-auto" v-show="toggle_search == 'resources'">
          <v-col cols="12">
            <v-text-field
              rounded
              v-model.trim="resource.text"
              placeholder="Search"
              outlined
              dense
              prepend-inner-icon="mdi-magnify"
              hide-details
              clearable
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <label>{{ 'Hosting Institution:' }}</label>
            <v-autocomplete
              class="mt-2"
              v-model="resource.institutions"
              :items="institutions"
              :item-value="'id'"
              :item-text="'name'"
              @change="updateProviders(resource.institutions)"
              outlined
              multiple
              clearable
              :placeholder="'Hosting Institution'"
              hide-details
              dense
            ></v-autocomplete>
          </v-col>
          <v-col cols="12">
            <label>{{ 'Provider' }}</label>
            <v-autocomplete
              class="mt-2"
              v-model="resource.providers"
              :items="providers"
              :item-value="'id'"
              :item-text="'name'"
              outlined
              multiple
              clearable
              :placeholder="'Provider'"
              hide-details
              dense
            ></v-autocomplete>
          </v-col>
          <v-col cols="12">
            <label>{{ 'Scientific Domain:' }}</label>
            <v-autocomplete
              class="mt-2"
              v-model="resource.domains"
              :items="domains"
              @change="updateSubDomains(resource.domains)"
              outlined
              multiple
              clearable
              :placeholder="'Scientific Domain'"
              hide-details
              dense
            ></v-autocomplete>
          </v-col>
          <v-col cols="12">
            <label>{{ 'Scientific Subdomain:' }}</label>
            <v-autocomplete
              class="mt-2"
              v-model="resource.subDomains"
              :items="subDomains"
              :item-value="'id'"
              :item-text="'subDomain'"
              outlined
              multiple
              clearable
              :placeholder="'Scientific Subdomain'"
              hide-details
              dense
            ></v-autocomplete>
          </v-col>
          <v-col cols="12">
            <label>{{ 'Category:' }}</label>
            <v-autocomplete
              class="mt-2"
              v-model="resource.categories"
              :items="categories"
              @change="updateSubCategories(resource.categories)"
              outlined
              multiple
              clearable
              :placeholder="'Category'"
              hide-details
              dense
            ></v-autocomplete>
          </v-col>
          <v-col cols="12">
            <label>{{ 'Subcategory:' }}</label>
            <v-autocomplete
              class="mt-2"
              v-model="resource.subCategories"
              :items="subCategories"
              :item-value="'id'"
              :item-text="'subCategory'"
              outlined
              multiple
              clearable
              :placeholder="'Subcategory'"
              hide-details
              dense
            ></v-autocomplete>
          </v-col>
          <v-col cols="12">
            <label>{{ 'Access Mode:' }}</label>
            <v-autocomplete
              class="mt-2"
              v-model="resource.accessModes"
              :items="accessModes"
              :item-value="'id'"
              :item-text="'name'"
              outlined
              multiple
              clearable
              :placeholder="'Access Mode'"
              hide-details
              dense
            ></v-autocomplete>
          </v-col>
          <v-col cols="12">
            <label>{{ 'Access Type:' }}</label>
            <v-autocomplete
              class="mt-2"
              v-model="resource.accessTypes"
              :items="accessTypes"
              :item-value="'id'"
              :item-text="'name'"
              outlined
              multiple
              clearable
              :placeholder="'Access Type'"
              hide-details
              dense
            ></v-autocomplete>
          </v-col>
          <v-col cols="12">
            <label>{{ 'Target Users:' }}</label>
            <v-autocomplete
              class="mt-2"
              v-model="resource.targets"
              :items="targets"
              :item-value="'id'"
              :item-text="'name'"
              outlined
              multiple
              clearable
              :placeholder="'Target Users'"
              hide-details
              dense
            ></v-autocomplete>
          </v-col>
          <!-- <v-col cols="6">
            <v-checkbox
              class="mt-0"
              v-model="resource.noCost"
              :label="'No Cost'"
              hide-details
              dense
            ></v-checkbox>
          </v-col> -->
        </v-row>

        <!-- Providers -->
        <v-row class="mx-0 px-2 mb-auto" v-show="toggle_search == 'providers'">
          <v-col cols="12">
            <v-text-field
              rounded
              v-model.trim="provider.text"
              placeholder="Search"
              outlined
              clearable
              prepend-inner-icon="mdi-magnify"
              hide-details
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <label>{{ 'Hosting Institution:' }}</label>
            <v-autocomplete
              class="mt-2"
              v-model="provider.institutions"
              :items="institutions"
              :item-value="'id'"
              :item-text="'name'"
              outlined
              multiple
              clearable
              :placeholder="'Hosting Institution'"
              hide-details
              dense
            ></v-autocomplete>
          </v-col>
          <v-col cols="12">
            <label>{{ 'Scientific Domain:' }}</label>
            <v-autocomplete
              v-model="provider.domains"
              :items="domains"
              outlined
              multiple
              clearable
              :placeholder="'Scientific Domain'"
              hide-details
              dense
            ></v-autocomplete>
          </v-col>
          <v-col cols="12">
            <label>{{ 'Scientific Subdomain:' }}</label>
            <v-autocomplete
              class="mt-2"
              v-model="provider.subDomains"
              :items="subDomains"
              :item-value="'id'"
              :item-text="'subDomain'"
              outlined
              multiple
              clearable
              :placeholder="'Scientific Subdomain'"
              hide-details
              dense
            ></v-autocomplete>
          </v-col>
          <v-col cols="12">
            <label>{{ 'Structure Type:' }}</label>
            <v-autocomplete
              class="mt-2"
              v-model="provider.structureTypes"
              :items="structureTypes"
              :item-value="'id'"
              :item-text="'name'"
              outlined
              multiple
              clearable
              :placeholder="'Structure Type'"
              hide-details
              dense
            ></v-autocomplete>
          </v-col>
        </v-row>

        <!-- Actions -->
        <v-row class="mx-0 px-2 mt-2">
          <v-col cols="6" class="d-flex justify-end">
            <v-btn
              block
              depressed
              large
              text
              @click="clearFilters"
              class="primary200--text font-weight-bold"
              data-cy="submit"
            >
              Clear
            </v-btn>
          </v-col>
          <v-col cols="6">
            <v-btn
              block
              depressed
              rounded
              large
              color="primary200"
              @click="triggerFilters"
              class="white--text font-weight-bold"
              data-cy="submit"
              >Done
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-navigation-drawer>
</template>

<script>
import base from '@/services/base-service';
import EventBus from '@/helpers/event-bus';

export default {
  name: 'Filtering',
  mixins: [base],
  data() {
    return {
      filterDrawer: false,
      toggle_search: 'resources',
      loadingFilterComponents: -10,
      resource: {
        text: null,
        providers: [],
        domains: [],
        subDomains: [],
        categories: [],
        subCategories: [],
        // isEquipment: false,
        accessTypes: [],
        accessModes: [],
        institutions: [],
        targets: [],
        noCost: false,
      },
      patent: {
        text: null,
        fillingDate: [],
        issueDate: [],
        expirationDate: [],
        patentStatuses: [],
        technologies: [],
        providers: [],
      },
      equipment: {
        text: null,
        institutions: [],
        providers: [],
        domains: [],
        subDomains: [],
        equipmentSubCategories: [],
        accessModes: [],
        accessTypes: [],
        targets: [],
        noCost: false,
      },
      hosting: {
        text: null,
        ecosystemStakeholders: [],
        areasOfActivity: [],
      },
      defaultHosting: {
        text: null,
        ecosystemStakeholders: [],
        areasOfActivity: [],
      },
      defaultPatent: {
        text: null,
        fillingDate: [],
        issueDate: [],
        expirationDate: [],
        patentStatus: [],
        technologies: [],
        providers: [],
      },
      defaultEquipment: {
        text: null,
        institutions: [],
        providers: [],
        domains: [],
        subDomains: [],
        equipmentSubCategories: [],
        accessModes: [],
        accessTypes: [],
        targets: [],
        noCost: false,
      },
      defaultResource: {
        text: null,
        providers: [],
        domains: [],
        subDomains: [],
        categories: [],
        subCategories: [],
        // isEquipment: false,
        accessTypes: [],
        accessModes: [],
        institutions: [],
        targets: [],
        noCost: false,
      },
      provider: {
        text: null,
        institutions: [],
        domains: [],
        subDomains: [],
        structureTypes: [],
      },
      defaultProvider: {
        text: null,
        institutions: [],
        domains: [],
        subDomains: [],
        structureTypes: [],
      },
      providers: [],
      allProviders: [],
      institutions: [],
      domains: [],
      equipmentSubCategories: [],
      allDomains: [],
      subDomains: [],
      allSubDomains: [],
      structureTypes: [],
      accessTypes: [],
      accessModes: [],
      categories: [],
      allCategories: [],
      allSubCategories: [],
      targets: [],
      mountViews: false,
      fillingDateMenu: false,
      issueDateMenu: false,
      expirationDateMenu: false,
      patentStatuses: [],
      technologies: [],
      ecosystemStakeholders: [],
      areasOfActivity: [],
    };
  },
  created() {
    EventBus.$on('filtering', this.drawer);
  },
  beforeDestroy() {
    EventBus.$off('filtering', this.drawer);
  },
  mounted() {
    this.axios
      .get('/api/v1/providers/light?size=-1')
      .then(res => (this.providers = res.data.content))
      .finally(() => {
        this.allProviders = this.providers;
        this.loadingFilterComponents++;
      });
    this.axios
      .get('/api/v1/hosting-institutions/all')
      .then(res => (this.institutions = res.data))
      .finally(() => {
        this.loadingFilterComponents++;
      });
    this.getStructureTypes().then(res => {
      this.structureTypes = res.data.content;
      this.loadingFilterComponents++;
    });
    this.getScientificDomains().then(res => {
      this.domains = res.data.content;
      this.allDomains = res.data.content;
      this.loadingFilterComponents++;
    });
    this.getScientificSubdomains().then(res => {
      this.subDomains = res.data.content;
      this.allSubDomains = res.data.content;
      this.loadingFilterComponents++;
    });
    this.axios.get('api/v1/resource-categories').then(res => {
      this.categories = res.data.content;
      this.allCategories = res.data.content;
      this.loadingFilterComponents++;
    });
    this.axios.get('/api/v1/resource-subcategories').then(res => {
      this.subCategories = res.data.content;
      this.allSubCategories = res.data.content;
      this.loadingComponents++;
    });
    this.axios.get('/api/v1/subcategories-equipment').then(res => {
      this.equipmentSubCategories = res.data.content;
    });
    this.getAccessTypes().then(res => {
      this.accessTypes = res.data.content;
      this.loadingFilterComponents++;
    });
    this.getAccessModes().then(res => {
      this.accessModes = res.data.content;
      this.loadingFilterComponents++;
    });
    this.getTargets().then(res => {
      this.targets = res.data.content;
      this.loadingFilterComponents++;
    });
    this.axios.get('/api/v1/patent-status').then(res => {
      this.patentStatuses = res.data.content;
      this.loadingFilterComponents++;
    });
    this.axios.get('/api/v1/technologies').then(res => {
      this.technologies = res.data.content;
      this.loadingFilterComponents++;
    });
    this.getEcosystemStakeholderProfile().then(res => {
      this.ecosystemStakeholders = res.data.content;
    });
    this.getAreasOfActivities().then(res => {
      this.areasOfActivity = res.data.content;
    });
  },
  computed: {
    fillingDateRangeText() {
      return this.patent.fillingDate.join(' ~ ');
    },
    issueDateRangeText() {
      return this.patent.issueDate.join(' ~ ');
    },
    expirationDateRangeText() {
      return this.patent.expirationDate.join(' ~ ');
    },
  },
  methods: {
    drawer(params) {
      console.log(params);
      this.filterDrawer = params;
    },
    clearFilters() {
      console.log('Clear filters');
      if (this.toggle_search == 'providers') {
        this.provider = JSON.parse(JSON.stringify(this.defaultProvider));
      } else if (this.toggle_search == 'equipment') {
        this.equipment = JSON.parse(JSON.stringify(this.defaultEquipment));
      } else if (this.toggle_search == 'resources') {
        this.resource = JSON.parse(JSON.stringify(this.defaultResource));
      } else if (this.toggle_search == 'patents') {
        this.patent = JSON.parse(JSON.stringify(this.defaultPatent));
      } else if (this.toggle_search == 'hostingInstitutions') {
        this.hosting = JSON.parse(JSON.stringify(this.defaultHosting));
      }
    },
    triggerFilters() {
      console.log('Trigger filters');
      const query = {};
      if (this.toggle_search == 'providers') {
        for (const attr in this.provider) {
          if (this.provider[attr]) {
            if (Array.isArray(this.provider[attr]) && this.provider[attr].length != 0) {
              query[attr] = this.provider[attr].join();
            } else {
              query[attr] = this.provider[attr];
            }
          }
        }
        if (this.$store.getters.roles) {
          this.$router.push({
            path: '/marketplace/providers',
            query: {
              ...query,
              selectedCatalogue: 'Browse the Catalogue of Providers',
              marketplaceProvidersViewAll: true,
            },
          });
        } else {
          this.$router.push({
            path: '/public-catalogue-marketplace/providers',
            query: {
              ...query,
              selectedCatalogue: 'Browse the Catalogue of Providers',
              marketplaceProvidersViewAll: true,
            },
          });
        }
      } else if (this.toggle_search == 'resources') {
        for (const attr in this.resource) {
          if (this.resource[attr]) {
            if (Array.isArray(this.resource[attr]) && this.resource[attr].length != 0) {
              query[attr] = this.resource[attr].join();
            } else {
              query[attr] = this.resource[attr];
            }
          }
        }
        if (this.$store.getters.roles) {
          this.$router.push({
            path: '/marketplace/services',
            query: {
              ...query,
              selectedCatalogue: 'Browse the Catalogue of Services',
              marketplaceServicesViewAll: true,
            },
          });
        } else {
          this.$router.push({
            path: '/public-catalogue-marketplace/services',
            query: {
              ...query,
              selectedCatalogue: 'Browse the Catalogue of Services',
              marketplaceServicesViewAll: true,
            },
          });
        }
      } else if (this.toggle_search == 'equipment') {
        for (const attr in this.equipment) {
          if (this.equipment[attr]) {
            if (Array.isArray(this.equipment[attr]) && this.equipment[attr].length != 0) {
              query[attr] = this.equipment[attr].join();
            } else {
              query[attr] = this.equipment[attr];
            }
          }
        }
        if (this.$store.getters.roles) {
          this.$router.push({
            path: '/marketplace/equipment',
            query: {
              ...query,
              selectedCatalogue: 'Browse the Catalogue of Equipment',
              marketplaceEquipmentViewAll: true,
            },
          });
        } else {
          this.$router.push({
            path: '/public-catalogue-marketplace/equipment',
            query: {
              ...query,
              selectedCatalogue: 'Browse the Catalogue of Equipment',
              marketplaceEquipmentViewAll: true,
            },
          });
        }
      } else if (this.toggle_search == 'patents') {
        for (const attr in this.patent) {
          if (this.patent[attr]) {
            if (Array.isArray(this.patent[attr]) && this.patent[attr].length != 0) {
              query[attr] = this.patent[attr].join();
            } else {
              query[attr] = this.patent[attr];
            }
          }
        }

        if (this.$store.getters.roles) {
          this.$router.push({
            path: '/marketplace/patents',
            query: {
              ...query,
              selectedCatalogue: 'Browse the Catalogue of Patents',
              marketplacePatentsViewAll: true,
            },
          });
        } else {
          this.$router.push({
            path: '/public-catalogue-marketplace/patents',
            query: {
              ...query,
              selectedCatalogue: 'Browse the Catalogue of Patents',
              marketplacePatentsViewAll: true,
            },
          });
        }
      } else if (this.toggle_search == 'hostingInstitutions') {
        for (const attr in this.hosting) {
          if (this.hosting[attr]) {
            if (Array.isArray(this.hosting[attr]) && this.hosting[attr].length != 0) {
              query[attr] = this.hosting[attr].join();
            } else {
              query[attr] = this.hosting[attr];
            }
          }
        }

        if (this.$store.getters.roles) {
          this.$router.push({
            path: '/marketplace/hosting-institutions',
            query: {
              ...query,
              selectedCatalogue: 'Browse the Catalogue of Hosting Institutions',
            },
          });
        } else {
          this.$router.push({
            path: '/public-catalogue-marketplace/hosting-institutions',
            query: {
              ...query,
              selectedCatalogue: 'Browse the Catalogue of Hosting Institutions',
            },
          });
        }
      }
    },
    updateSubCategories(selected) {
      this.subCategories = [];
      if (selected.length > 0) {
        for (let i of selected) {
          let list = this.allSubCategories.filter(subCat => subCat.category === i);
          this.subCategories.push.apply(this.subCategories, list);
        }
      } else {
        this.subCategories = this.allSubCategories;
      }
    },
    updateSubDomains(selected) {
      this.subDomains = [];
      if (selected.length > 0) {
        for (let i of selected) {
          let list = this.allSubDomains.filter(subCat => subCat.domain === i);
          this.subDomains.push.apply(this.subDomains, list);
        }
      } else {
        this.subDomains = this.allSubDomains;
      }
    },
    updateProviders(selected) {
      this.providers = [];
      if (selected.length > 0) {
        for (let i of selected) {
          let list = this.allProviders.filter(prov => prov.hostingInstitution.id === i);
          this.providers.push.apply(this.providers, list);
        }
      } else {
        this.providers = this.allProviders;
      }
    },
  },
};
</script>

<style scoped></style>
